export const ClientTableTitle = [
    { label: 'ລຳດັບ' },
    { label: 'ຊື່ເຕັມ' },
    { label: 'ເບີໂທ' },
    { label: 'ຕຳແໜ່ງ' },
    { label: 'ກະຊວງ ຫລື ອົງການທຽບເທົ່າ' },
    { label: 'ແຂວງ' },
    { label: 'ກົມ' },
    { label: 'ບົດບາດ' },
    { label: 'ການຈັດການ' },
];